import Restocking from './restocking/main'
import Observation from '@/domains/agenda/activities/observation/observation';

export default {
	name: 'agenda-others',
	components: {
		Restocking,
		Observation
	},
	data: () => ({

	})
};



// WEBPACK FOOTER //
// ./sources/domains/agenda/others/index.js